/**
 * PageWrapper Component
 *
 * Wraps page content with standard layout and meta tag management.
 * Sets the page title and meta description on mount.
 *
 * NOTE: Route protection is now handled by ProtectedRoute in contentRoutes.tsx.
 * The legacy isProtected prop and AuthContext check have been removed
 * as they were disabled (navigate was commented out) and replaced by
 * the ProtectedRoute component which uses Redux login state.
 */
import React, { forwardRef, ReactElement, useLayoutEffect } from 'react';
import classNames from 'classnames';
import { ISubHeaderProps } from '../SubHeader/SubHeader';
import { IPageProps } from '../Page/Page';

interface IPageWrapperProps {
	title?: string;
	description?: string;
	children:
		| ReactElement<ISubHeaderProps>[]
		| ReactElement<IPageProps>
		| ReactElement<IPageProps>[];
	className?: string;
}
const PageWrapper = forwardRef<HTMLDivElement, IPageWrapperProps>(
	({ title, description, className, children }, ref) => {
		useLayoutEffect(() => {
			// @ts-ignore
			document.getElementsByTagName('TITLE')[0].text = `${title ? `${title} | ` : ''}${
				process.env.REACT_APP_SITE_NAME
			}`;
			// @ts-ignore
			document
				?.querySelector('meta[name="description"]')
				.setAttribute('content', description || process.env.REACT_APP_META_DESC || '');
		});

		return (
			<div ref={ref} className={classNames('page-wrapper', 'container-fluid', className)}>
				{children}
			</div>
		);
	},
);
PageWrapper.displayName = 'PageWrapper';

export default PageWrapper;
